export default "__VITE_ASSET__C2cIt52K__"